
import * as Yup from 'yup';
import 'yup-phone';
import { PhoneNumberUtil } from 'google-libphonenumber';
const customPhoneValidator = (data) => {
  const phoneUtil = PhoneNumberUtil.getInstance();

  try {
    const number = phoneUtil.parseAndKeepRawInput(
      `${data.phoneNumber}`,
      phoneUtil.getRegionCodeForCountryCode(data.countryCode)
    );
    return phoneUtil.isValidNumber(number);
  } catch (err) {
    return false;
  }
};
const subtractYearsFromCurrentDate = (years) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const subtractedYear = currentYear - years;

  const subtractedDate = new Date(currentDate);
  subtractedDate.setFullYear(subtractedYear);

  return subtractedDate;
};

export const PersonalDetailsValidationSchema = Yup.object().shape({
  isDifferentPermanentAddress: Yup.boolean(),
  phoneNumbers: Yup.array().of(
    Yup.object().test('custom-phone-validation', 'Please provide a valid phone number', customPhoneValidator)
  ),
  permAddress1: Yup.string().when('isDifferentPermanentAddress', {
    is: true,
    then: Yup.string().required('Address 1 is required.'),
  }),
  permCity: Yup.string().when('isDifferentPermanentAddress', {
    is: true,
    then: Yup.string().required('City is required.'),
  }),
  permState: Yup.string().when('isDifferentPermanentAddress', {
    is: true,
    then: Yup.string().required('State is required.'),
  }),
  permState: Yup.string().when('isDifferentPermanentAddress', {
    is: true,
    then: Yup.string().required('Country is required.'),
  }),
  permPincode: Yup.string().when('isDifferentPermanentAddress', {
    is: true,
    then: Yup.string().required('PIN Code is required.'),
  }),
  state: Yup.string().required('State is required.'),
  country: Yup.string().required('Country is required.'),
  pincode: Yup.string().required('PIN Code is required.'),
  address1: Yup.string().optional().nullable(),
  city: Yup.string().required('City is required.'),
  emailIds: Yup.array().of(Yup.string().email('Please provide a valid Email Id.').required('Email ID is required.')),
  dob: Yup.date()
    .max(subtractYearsFromCurrentDate(18), 'You should be atleast 18 years')
    .required('DOB cannot be empty.'),
  salutation: Yup.string().required('Salutation is required.'),
  firstName: Yup.string()
    .required('First Name is required.')
    .matches(/^[A-Za-z\s]+$/, 'First Name should contain only alphabets and spaces'),
  lastName: Yup.string()
    .required('Last Name is required.')
    .matches(/^[A-Za-z\s]+$/, 'Last Name should contain only alphabets and spaces'),
  middleName: Yup.string()
    .optional()
    .matches(/^[A-Za-z\s]+$/, 'Middle Name should contain only alphabets and spaces')
    .nullable(),
  gender: Yup.string().required('Gender is required.'),
  maritalStatus: Yup.string()
    .optional()
    .nullable(),
});